"use client";
import type { MutableRefObject, ReactElement, RefObject } from "react";
import type { MotionValue } from "framer-motion";
import { TimelinePeriodRow } from "./TimelinePeriodRow";
import { TimelineRulers } from "./TimelineRulers";
import { TimelineSectionHeaders } from "./TimelineSectionHeaders";
import { TimelineTrack } from "./TimelineTrack";
import type { TimelineEventHoverPayload } from "./TimelinePeriod";
import type { ParsedTimeline } from "./timeline-types";
import type { TimelineLayoutMetrics } from "./timeline-root-types";
const CSS_BOX_SIZING_CONTENT_BOX = "content-box";
export interface TimelineCanvasProps {
    centeredPeriodIndex: number;
    collapsedSections: Set<number>;
    innerRef: RefObject<HTMLDivElement | null>;
    isNeedleReady: boolean;
    layout: TimelineLayoutMetrics;
    needleActive: boolean;
    needleOpacity: MotionValue<number>;
    onHoverEvent: (payload: TimelineEventHoverPayload | null) => void;
    onToggleSection: (sectionIndex: number) => void;
    parsed: ParsedTimeline;
    periodRefs: MutableRefObject<Array<HTMLDivElement | null>>;
    sectionBoundaryIndices: Set<number>;
    sidePad: number;
    snapCandidateCount: number;
    snappedNeedleX: MotionValue<number>;
    snappedPeriodIndex: number | null;
    snappedSectionColor: string;
    trackHighlightGradient: string;
}
export function TimelineCanvas({ centeredPeriodIndex, collapsedSections, innerRef, isNeedleReady, layout, needleActive, needleOpacity, onHoverEvent, onToggleSection, parsed, periodRefs, sectionBoundaryIndices, sidePad, snapCandidateCount, snappedNeedleX, snappedPeriodIndex, snappedSectionColor, trackHighlightGradient, }: TimelineCanvasProps): ReactElement {
    return (
      <div data-el="Cmarkdowntimeline/TimelineCanvas/Root" style={{
            position: "relative",
            width: layout.contentWidth,
            height: layout.chartHeight,
            boxSizing: CSS_BOX_SIZING_CONTENT_BOX,
            paddingLeft: sidePad,
            paddingRight: sidePad,
            flexShrink: 0,
        }}>
        <div ref={innerRef} style={{
            position: "relative",
            width: layout.contentWidth,
            height: layout.chartHeight,
        }}>
          <TimelineRulers chartHeight={layout.chartHeight} periods={parsed.periods} sectionBoundaryIndices={sectionBoundaryIndices}/>
          <TimelineSectionHeaders chartHeight={layout.chartHeight} collapsedSections={collapsedSections} onToggleSection={onToggleSection} sections={parsed.sections}/>
          <TimelineTrack hasSnapCandidates={snapCandidateCount > 0} isNeedleReady={isNeedleReady} layout={layout} needleOpacity={needleOpacity} snappedNeedleX={snappedNeedleX} snappedSectionColor={snappedSectionColor} trackHighlightGradient={trackHighlightGradient}/>
          <TimelinePeriodRow centeredPeriodIndex={centeredPeriodIndex} chartHeight={layout.chartHeight} collapsedSections={collapsedSections} needleActive={needleActive} onHoverEvent={onHoverEvent} periodRefs={periodRefs} periods={parsed.periods} snappedNeedleX={snappedNeedleX} snappedPeriodIndex={snappedPeriodIndex} trackY={layout.trackY}/>
        </div>
      </div>
    );
}
